<template>
    <v-container>
        <div class="ma-5">
            <h3 class="text-center">{{ $t('album.title') }}</h3>
        </div>

        <div v-if="isLoading">
            <div class="d-flex justify-center my-8" aria-live="polite">
                <v-progress-circular indeterminate color="primary" size="36" />
                <span class="ml-3">{{ $t('common.loading') || 'Loading…' }}</span>
            </div>
        </div>

        <!-- <div v-if="drawings.length">
            <v-row v-for="(drawing, index) in drawings.slice().reverse()" :key="index" class="mb-4 justify-center">
                <v-card class="d-flex justify-space-between align-center flex-column mt-1" outlined
                    style="border-color: rgba(173, 216, 230, 1); border-width: 2px;">
                    <v-card-text class="d-flex justify-space-between align-center pa-1">
                        <div class="image-container">
                            <img :src="drawing.image" alt="User Image">
                        </div>
                        <div v-if="getPicture(drawing.penguin_name)" class="json-image-container pa-0 ma-0">
                            <img :src="getPicture(drawing.penguin_name)" alt="Matching Image">
                        </div>
                    </v-card-text>
                    <v-card-text class="timestamp-text pa-0">
                        {{ drawing.penguin_name }}<span class="timestamp">{{ drawing.timestamp }}</span>
                    </v-card-text>
                </v-card>
            </v-row> -->
        <div v-else-if="enrichedDrawings.length">
            <!-- <v-row v-for="(drawing, index) in enrichedDrawings.slice().reverse()" :key="drawing._key || index"
                class="mb-4 justify-center"> -->
            <v-row v-for="(drawing, index) in drawingsReversed" :key="drawing._key || index"
                class="mb-4 justify-center">
                <v-card class="d-flex justify-space-between align-center flex-column mt-1" outlined
                    style="border-color: rgba(173, 216, 230, 1); border-width: 2px;">
                    <v-card-text class="d-flex justify-space-between align-center pa-1">
                        <div class="image-container">
                            <img :src="drawing.image" alt="User Image">
                        </div>

                        <div v-if="drawing.matchPicture" class="json-image-container pa-0 ma-0">
                            <img :src="drawing.matchPicture" alt="Matching Image">
                        </div>
                    </v-card-text>

                    <v-card-text class="timestamp-text pa-0">
                        {{ drawing.localizedName }}
                        <span class="timestamp">{{ drawing.timestamp }}</span>
                    </v-card-text>
                </v-card>
            </v-row>
        </div>

        <div v-else>
            <p>{{ $t('album.empty') }}</p>
        </div>
    </v-container>
</template>






<script>
import { fire, getPrevScreen, setCurrentScreen } from '@/utils/logger';

export default {
    props: ['aquarium'], // ルーターから受け取るプロップス
    data() {
        return {
            drawings: [], // 取得した画像とペンギン名を保存する配列
            json: [],
            // log用
            viewId: null,
            viewStart: 0,
            activeStart: 0,
            activeTotal: 0,
            viewLeft: false,

            // album_view 用
            maxScrollPct: 0,    // セッション中の最大スクロール到達率（0〜100）
            itemCount: 0,       // 表示しているアイテム総数（= enrichedDrawings.length）

            isLoading: true,     // ← 追加：ロード中かどうか
            loadError: null,     // ← 追加：エラー表示用（任意）
        };
    },
    async created() {
        // await this.fetchJson(this.aquarium);
        // this.fetchDrawings();

        this.$store.commit('setAquarium', { aquarium: this.aquarium });
        try {
            // 図鑑用の辞書群を先にロード
            if (!this.$store.state.baseById) {
                await this.$store.dispatch('loadPenguinBase');
            }
            if (!this.$store.state.penguinLocaleDict) {
                await this.$store.dispatch('loadPenguinLocale', this.$i18n.locale);
            }
            if (!this.$store.state.jaNameToId) {
                await this.$store.dispatch('buildJaReverseMap');
            }

            // UID が確定してから取得（未確定なら待つ）
            const tryFetch = () => {
                const uid = this.$store.state.user?.uid;
                if (uid && uid !== 'guest') {
                    this.fetchDrawings();
                    return true;
                }
                return false;
            };
            if (!tryFetch()) {
                // まだなら監視して、確定した瞬間に一度だけ取得
                this._unwatchUid = this.$watch(
                    () => this.$store.state.user?.uid,
                    () => { if (tryFetch() && this._unwatchUid) this._unwatchUid(); },
                    { immediate: false }
                );
            }
        } catch (e) {
            this.loadError = e?.message || 'load failed';
        } finally {
            // fetchDrawings 内で完了時に isLoading=false を落とすのでここでは触らない
        }
    },
    beforeDestroy() {
        this.flushLeave();
        window.removeEventListener('scroll', this.onScroll);
        document.removeEventListener('visibilitychange', this.onVis);
        if (this._unwatchUid) this._unwatchUid();
    },
    mounted() {
        this.$returnScroll();
        // --- page_view (album) ---
        this.viewId = crypto.randomUUID();
        this.viewStart = performance.now();
        this.activeStart = this.viewStart;
        this.activeTotal = 0;

        fire('page_view', {
            view_id: this.viewId,
            screen: 'album',
            from: getPrevScreen(),
            locale: this.$i18n.locale,
            aquarium: this.aquarium,
        });
        setCurrentScreen('album');

        // スクロール深度を監視（window全体でOK）
        window.addEventListener('scroll', this.onScroll, { passive: true });
        document.addEventListener('visibilitychange', this.onVis);
        window.addEventListener('beforeunload', this.flushLeave, { once: true });
    },
    computed: {
        drawingsReversed() {
            const list = this.enrichedDrawings || [];
            // イミュータブルに1回だけ逆順
            return [...list].reverse();
        },

        // store からよく使う辞書を取りやすく
        baseById() { return this.$store.state.baseById || {}; },
        dict() { return this.$store.state.penguinLocaleDict || {}; },
        nameDict() { return this.dict.penguin?.name || {}; },
        jaNameToId() { return this.$store.state.jaNameToId || {}; },

        currentDrawingsRaw() {
            const all = this.drawings || [];
            const cur = (this.aquarium || '').trim();
            
            return all.filter(d => {
                const aq = (d.aquarium || '').trim();
                if (aq) {
                    return aq === cur;            // ① aquarium が入っている最新データは一致のみ
                }
                // ② 古いデータ（aquarium空）の救済：id が baseById に居れば「今の水族館の個体」と判定
                const id = this.resolvePenguinId(d);
                return !!(id && this.baseById[id]);
            });
        },
        /**
         * drawings（サーバ生データ）を表示用に増強：
         * - penguin_id（新） or penguin_name（旧=日本語名）→ id を確定
         * - id から picture と nameLabel を解決
         */
        enrichedDrawings() {
            // ここで「空 or Unknown」を除外
            const raw = (this.currentDrawingsRaw || []).filter(d => {
                const name = (d.penguin_name || '').trim();
                return name && !/^unknown$/i.test(name);  // 大文字小文字を区別しない
            });

            return raw.map(d => {
                const id = this.resolvePenguinId(d);
                const base = id ? this.baseById[id] : null;

                const matchPicture = base?.picture || null;
                const localizedName = id ? (this.nameDict[id] || id)
                    : (d.penguin_name); // ここは Unknown はすでに除外済み

                return {
                    ...d,
                    matchPicture,
                    localizedName,
                };
            });
        }
    },
    watch: {
        enrichedDrawings(newList) {
            this.itemCount = Array.isArray(newList) ? newList.length : 0;
        },

        // ロケールが変わったら名前だけ再ローカライズ（API再取得不要）
        '$i18n.locale': {
            async handler(newLocale) {
                await this.$store.dispatch('loadPenguinLocale', newLocale);
                // enrichedDrawings は computed なので勝手に再計算される
            }
        }
    },
    methods: {
        // fetchDrawings() {
        //     this.$axios
        //         .post('https://dev.pensaku.com/api/pensaku/get_drawing.php', { uid: this.$store.state.user.uid })
        //         .then((response) => {
        //             if (response.data.success) {
        //                 this.drawings = response.data.drawings;
        //             } else {
        //                 console.error(response.data.message);
        //             }
        //         })
        //         .catch((error) => {
        //             console.error("Failed to fetch images:", error);
        //         });
        // },
        // async fetchJson(fileName) {
        //     try {
        //         const response = await this.$axios.get(`https://dev.pensaku.com/api/response_json.php?file=${fileName}`);
        //         this.json = response.data;
        //         // console.log(response.data)
        //     } catch (error) {
        //         console.error('データの取得に失敗しました:', error);
        //         if (error.response) {
        //             console.error('レスポンスエラー:', error.response);
        //         } else if (error.request) {
        //             console.error('リクエストエラー:', error.request);
        //         } else {
        //             console.error('その他のエラー:', error.message);
        //         }
        //     }
        // },
        // getPicture(penguinName) {
        //     const matchingEntry = this.json.find(item => item.name === penguinName);
        //     if (matchingEntry) {
        //         // console.log(`Found picture for ${penguinName}:`, matchingEntry.picture);
        //     } else {
        //         console.log(`No picture found for ${penguinName}`);
        //     }
        //     return matchingEntry ? matchingEntry.picture : null;
        // },


        fetchDrawings() {
            const uid = this.$store.state.user?.uid;
            if (!uid || uid === 'guest') return; // 念のため二重防衛

            this.isLoading = true;
            this.loadError = null;

            this.$axios
                .post('https://dev.pensaku.com/api/pensaku/get_drawing.php', { uid })
                .then((response) => {
                    if (response.data.success) {
                        console.log("Fetched drawings:", response.data);
                        // ここで key 用のフィールドを付けておくと混在しにくい
                        this.drawings = (response.data.drawings || []).map(d => ({
                            ...d,
                            _key: d.id || `${d.uid || uid}-${d.timestamp || Math.random()}`
                        }));
                    } else {
                        console.error(response.data.message);
                    }
                })
                .catch((error) => {
                    console.error("Failed to fetch images:", error);
                }).finally(() => {
                    this.isLoading = false;   // ← ここでロード完了
                });
        },

        /**
         * id 解決ロジック：
         * 1) penguin_id があればそれを採用
         * 2) それが無く、penguin_name が「日本語名」なら jaNameToId から引き直す
         * 3) それでも無ければ null
         */
        resolvePenguinId(d) {
            if (d.penguin_name && this.baseById[d.penguin_name]) return d.penguin_name;
            if (d.penguin_name && this.jaNameToId[d.penguin_name]) return this.jaNameToId[d.penguin_name];
            return null;
        },

        // 可視/不可視の切り替えで active_ms を積算
        onVis() {
            const now = performance.now();
            if (document.visibilityState === 'hidden') {
                this.activeTotal += now - this.activeStart;
            } else if (document.visibilityState === 'visible') {
                this.activeStart = now;
            }
        },

        // スクロール到達率（0〜100）を更新（最大値を保持）
        onScroll() {
            const doc = document.documentElement;
            const scrollTop = window.pageYOffset || doc.scrollTop || 0;
            const viewport = window.innerHeight || doc.clientHeight || 0;
            const full = doc.scrollHeight || 1;
            const pct = Math.min(100, Math.max(0, ((scrollTop + viewport) / full) * 100));
            if (pct > this.maxScrollPct) this.maxScrollPct = pct;
        },

        // 離脱時に page_leave と album_view を送る
        flushLeave() {
            if (!this.viewStart || this.viewLeft) return;
            this.viewLeft = true;

            const now = performance.now();
            const total = now - this.viewStart;
            if (document.visibilityState === 'visible') {
                this.activeTotal += now - this.activeStart;
            }

            // 1) page_leave
            fire('page_leave', {
                view_id: this.viewId,
                screen: 'album',
                total_ms: Math.round(total),
                active_ms: Math.round(this.activeTotal),
            });

            // 2) album_view（アイテム数と最終スクロール深度）
            fire('album_view', {
                count: this.itemCount,
                scroll_depth_pct: Math.round(this.maxScrollPct),
            });
        },
    }
};
</script>

<style scoped>
.image-container {
    width: 150px;
    /* 固定幅を設定 */
    height: 150px;
    /* 固定高さを設定 */
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    background-image: url('https://dev.pensaku.com/img/penguin_backimg1.png');
    background-size: cover;
    background-position: center;
    border-radius: 5px;
}

.json-image-container {
    width: 120px;
    /* 固定幅を設定 */
    height: 150px;
    /* 固定高さを設定 */
    display: flex;
    align-items: center;
    justify-content: center;
}

.image-container img,
.json-image-container img {
    max-width: 100%;
    max-height: 100%;
    object-fit: cover;
    border-radius: 5px;
}

.penguin-name {
    position: absolute;
    top: 5px;
    left: 5px;
    background-color: rgba(0, 0, 0, 0.5);
    color: white;
    padding: 2px 5px;
    border-radius: 3px;
    font-size: 12px;
}

.v-card {
    max-width: 600px;
    margin: auto;
    /* カードを中央揃えにする */
    text-align: center;
    /* 中央揃え */
}

.timestamp-text {
    width: 100%;
    text-align: center;
    margin-top: 10px;
}

.timestamp {
    color: gray;
    font-size: 14px;
    display: block;
}
</style>